export class Responsibles {
  [key: string]: any;
  bavFv?: string = "";
  bavFvEmail?: string = "";
  bavFvVertreter?: string = "";
  bavFvVertreterEmail?: string = "";
  bavFvVertreter2?: string = "";
  bavFvVertreter2Email?: string = "";
  mawiFv?: string = "";
  mawiFvEmail?: string = "";
  mawiFvVertreter?: string = "";
  mawiFvVertreterEmail?: string = "";
  mawiFvVertreter2?: string = "";
  mawiFvVertreter2Email?: string = "";
  bavRegio?: string = "";
  bavRegioEmail?: string = "";
  bavRegioVertreter?: string = "";
  bavRegioVertreterEmail?: string = "";
  bavRegioVertreter2?: string = "";
  bavRegioVertreter2Email?: string = "";
  mawiRegio?: string = "";
  mawiRegioEmail?: string = "";
  mawiRegioVertreter?: string = "";
  mawiRegioVertreterEmail?: string = "";
  mawiRegioVertreter2?: string = "";
  mawiRegioVertreter2Email?: string = "";
  bavCargo?: string = "";
  bavCargoEmail?: string = "";
  bavCargoVertreter?: string = "";
  bavCargoVertreterEmail?: string = "";
  bavCargoVertreter2?: string = "";
  bavCargoVertreter2Email?: string = "";
  mawiCargo?: string = "";
  mawiCargoEmail?: string = "";
  mawiCargoVertreter?: string = "";
  mawiCargoVertreterEmail?: string = "";
  mawiCargoVertreter2?: string = "";
  mawiCargoVertreter2Email?: string = "";
  bavFzi?: string = "";
  bavFziEmail?: string = "";
  bavFziVertreter?: string = "";
  bavFziVertreterEmail?: string = "";
  bavFziVertreter2?: string = "";
  bavFziVertreter2Email?: string = "";
  mawiFzi?: string = "";
  mawiFziEmail?: string = "";
  mawiFziVertreter?: string = "";
  mawiFziVertreterEmail?: string = "";
  mawiFziVertreter2?: string = "";
  mawiFziVertreter2Email?: string = "";
  bavNetz?: string = "";
  bavNetzEmail?: string = "";
  bavNetzVertreter?: string = "";
  bavNetzVertreterEmail?: string = "";
  bavNetzVertreter2?: string = "";
  bavNetzVertreter2Email?: string = "";
  mawiNetz?: string = "";
  mawiNetzEmail?: string = "";
  mawiNetzVertreter?: string = "";
  mawiNetzVertreterEmail?: string = "";
  mawiNetzVertreter2?: string = "";
  mawiNetzVertreter2Email?: string = "";
}
